import { LIFESTYLE_IMAGE_1, LIFESTYLE_IMAGE_2, ROUTINE_CHARTS_IMAGE } from '../data/images'
import { bonuses } from '../data/bonuses'
import { upsells } from '../data/upsells'

/**
 * Tiered warm-up. The hero is preloaded in index.tsx with high priority before
 * React mounts. Everything else is fetched only once the page is interactive,
 * in the order the buyer needs it, so nothing competes with the hero.
 *
 * Tier 2 — the upsell thumbnails. These live inside the modal that opens the
 *          instant a buyer taps the button, so they must already be cached.
 * Tier 3 — the demo images the buyer scrolls to next.
 * Tier 4 — the 12 bonus covers, the heaviest and last-seen group.
 */
const TIER_2 = upsells.map(upsell => upsell.image).filter((src): src is string => Boolean(src))

const TIER_3 = [ROUTINE_CHARTS_IMAGE, LIFESTYLE_IMAGE_1, LIFESTYLE_IMAGE_2]

const TIER_4 = bonuses.map(bonus => bonus.image).filter((src): src is string => Boolean(src))

function fetchImages(sources: string[]) {
  sources.forEach(src => {
    const image = new Image()
    image.decoding = 'async'
    image.src = src
  })
}

function whenIdle(callback: () => void, timeout: number) {
  const idle = (window as unknown as { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void })
    .requestIdleCallback

  if (typeof idle === 'function') idle(callback, { timeout })
  else window.setTimeout(callback, timeout)
}

export function warmUpImages() {
  if (typeof window === 'undefined') return

  const start = () => {
    whenIdle(() => fetchImages(TIER_2), 200)
    whenIdle(() => fetchImages(TIER_3), 900)
    whenIdle(() => fetchImages(TIER_4), 2200)
  }

  if (document.readyState === 'complete') start()
  else window.addEventListener('load', start, { once: true })
}
